import { generator } from '@philips-emr/tws-core/lib/client/event-listener';

const HPMSOnCreateMenu = generator('onCreateMenu');
const HPMSOnCreateOption = generator('onCreateOption');
const HPMSOnInformarParecerClick = generator('onInformarParecerClick');
const HPMSOnOpen = generator('onOpen');
const HPMSOnOpenAttachment = generator('onOpenAttachment');
const HPMSOnOpenModalDocumento = generator('onOpenModalDocumento');
const HPMSOnOptionClick = generator('onOptionClick');
const HPMSOnRenderAction = generator('onRenderAction');
const HPMSOnSelect = generator('onSelect');
const HPMSOnSubmitTermoUso = generator('onSubmitTermoUso');

export {
  HPMSOnCreateMenu,
  HPMSOnCreateOption,
  HPMSOnInformarParecerClick,
  HPMSOnOpen,
  HPMSOnOpenAttachment,
  HPMSOnOpenModalDocumento,
  HPMSOnOptionClick,
  HPMSOnRenderAction,
  HPMSOnSelect,
  HPMSOnSubmitTermoUso,
};
